import { useTranslation } from "@coworker/locales";
import {
  FilterValue,
  GroupFilter,
  InputFilter,
  InputType,
  RowVisibility,
} from "../../shared/filters/types/filter";
import { usePickupLocationsFilter } from "./usePickupLocationsFilter";
import { useRefillLocationsFilter } from "./useRefillLocationsFilter";
import { useLocationsFilter } from "./useLocationsFilter";

export const GROUP_LOCATIONS_ID = "groupLocations";

export function useGroupLocationsFilter(
  filterValues: FilterValue[]
): GroupFilter {
  const { t } = useTranslation();
  const filters: InputFilter[] = [
    usePickupLocationsFilter(filterValues),
    useRefillLocationsFilter(filterValues),
    useLocationsFilter(filterValues),
  ];
  const enabled = filters.reduce(
    (accumulator, filter) => (filter.enabled ? true : accumulator),
    false
  );

  return {
    inputType: InputType.Group,
    id: GROUP_LOCATIONS_ID,
    title: t("location3String"),
    enabled,
    filters,
    rowVisibility: RowVisibility.PillOnly,
  };
}
